import { Signal } from "../core/Signal.js";
import { BaseVideo } from "./video/BaseVideo.js";
import { IVideo } from "./video/IVideo.js";
import { VideoPlayerButton } from "./video/VideoPlayerButton.js";
import { VideoPlayerFullscreenButton } from "./video/VideoPlayerFullscreenButton.js";
import { VideoPlayerPlayButton } from "./video/VideoPlayerPlayButton.js";
import { VideoPlayerState } from "./video/VideoPlayerState.js";
import { VideoPlayerTimeline } from "./video/VideoPlayerTimeline.js";

export class VideoPlayer {
    public onStateChange = Signal.create<[VideoPlayerState]>();
    public onTimeChange = Signal.create<[number]>();
    public onBufferChange = Signal.create<[number]>();
    public onChangeVideo = Signal.create<[IVideo]>();

    public element: HTMLElement;
    public time: number = 0;
    public buffer: number = 0;
    public state: VideoPlayerState = VideoPlayerState.UNSTARTED;

    private static _uid: number = 1;

    private _container: HTMLDivElement;
    private _control: HTMLDivElement;
    private _buttonsLeft: HTMLDivElement;
    private _buttonsRight: HTMLDivElement;
    private _uid: string = "video-player-" + VideoPlayer._uid++;
    private _video: IVideo = null;
    private _timeline: VideoPlayerTimeline;

    constructor(element: HTMLElement = null) {
        this.element = element || document.createElement("div");
        this.element.className = "e5-video-player";
        this.element.innerHTML = `
                <div class="e5-video-player__container"></div>
                <div class="e5-video-player__control">
                    <div class="e5-video-player__control-bar">
                        <div class="e5-video-player__buttons e5-video-player__buttons--left"></div>
                        <div class="e5-video-player__buttons e5-video-player__buttons--right"></div>
                    </div>
                </div>
            `;
        this._container = this.element.querySelector(".e5-video-player__container");
        this._control = this.element.querySelector(".e5-video-player__control");
        this._buttonsLeft = this.element.querySelector(".e5-video-player__buttons--left");
        this._buttonsRight = this.element.querySelector(".e5-video-player__buttons--right");

        this._timeline = new VideoPlayerTimeline(this);
        this._control.prepend(this._timeline.element);

        // this.video = new YoutubeVideo();
        // this.video.load("Lkbuy5vIlSE");
        // this.video.load("YE7VzlLtp-4");

        this.video = new BaseVideo();
        this.video.load("http://distribution.bbb3d.renderfarming.net/video/mp4/bbb_sunflower_1080p_60fps_normal.mp4");
        // this.video.load("/video_small.mp4");

        this.addButton(new VideoPlayerPlayButton(this));
        this.addButton(new VideoPlayerFullscreenButton(this));
    }

    public addButton(button: VideoPlayerButton): void {
        if (!button.supported)
            return;
        button.create();
        if (button.position === "left")
            this._buttonsLeft.appendChild(button.element);
        else if (button.position === "right")
            this._buttonsRight.appendChild(button.element);
    }

    public get video(): IVideo {
        return this._video;
    }

    public set video(video: IVideo) {
        if (this._video === video)
            return;

        if (this._video) {
            this._video.onStateChange.remove(this._uid);
            this._video.onTimeChange.remove(this._uid);
            this._video.onBufferChange.remove(this._uid);
            this._video.element.remove();
        }
        this._video = video;
        if (this._video) {
            this._video.onStateChange.add(this.handleStateChange, this, this._uid);
            this._video.onTimeChange.add(this.handleTimeChange, this, this._uid);
            this._video.onBufferChange.add(this.handleBufferChange, this, this._uid);
            this._container.appendChild(this._video.element);
        }

        this.onChangeVideo.dispatch(video);

        this.handleTimeChange(video ? video.time : 0);
        this.handleBufferChange(video ? video.buffer : 0);
        this.handleStateChange(video ? video.state : VideoPlayerState.UNSTARTED);
    }

    private handleTimeChange(time: number): void {
        this.time = time;
        this.onTimeChange.dispatch(time);
    }

    private handleBufferChange(buffer: number): void {
        this.buffer = buffer;
        this.onBufferChange.dispatch(buffer);
    }

    private handleStateChange(state: VideoPlayerState): void {
        this.state = state;
        this.onStateChange.dispatch(state);
    }
}